import { ApplicationRef, inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import {
  IntelligenceSettings,
  IntelligenceSettingsActions,
  IntelligenceSettingsSelectors,
} from '@core/intelligence-data';

@Injectable({ providedIn: 'root' })
export class IntelligenceSettingsService {
  private readonly store = inject(Store);
  private readonly appRef = inject(ApplicationRef);
  private readonly intelligenceSettingsState = this.store.selectSignal(
    IntelligenceSettingsSelectors.state,
  );

  public readonly intelligenceSettings = this.store.selectSignal(
    IntelligenceSettingsSelectors.data,
  );

  constructor() {
    this.appRef.whenStable().then(() => this.fetchSettings());
  }

  public getSettings$() {
    return this.store.select(IntelligenceSettingsSelectors.data);
  }

  public fetchIfNotLoaded() {
    const { pending, loaded } = this.intelligenceSettingsState();
    if (pending || loaded) return;

    this.fetchSettings();
  }

  public fetchSettings() {
    this.store.dispatch(IntelligenceSettingsActions.fetch());
  }

  public updateSettings(settings: Partial<IntelligenceSettings>) {
    this.store.dispatch(IntelligenceSettingsActions.update({ payload: settings }));
  }
}
